// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*角标广告*/\n.connerAd--IEjC_th {\n    width: 100px;\n    height: 60px;\n    position: absolute;\n    right: 0;\n    bottom: 40px;\n    z-index: 201;\n    transition: bottom 0.5s ease-out;\n    -moz-transition: bottom 0.5s ease-out;\n    -webkit-transition: bottom 0.5s ease-out;\n    -o-transition: bottom 0.5s ease-out;\n}\n.connerAdHide-1rxnplnl {\n    display: none;\n}\n.connerAd--IEjC_th img {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n}\n.connerClose-23R5f3iu {\n    width: 16px;\n    height: 17px;\n    display: inline-block;\n    position: absolute;\n    right: 0;\n    background: url(//p1.ifengimg.com/a/2016/1219/icons.png) -350px 0 no-repeat;\n    cursor: pointer;\n}\n", ""]);
// Exports
exports.locals = {
	"connerAd": "connerAd--IEjC_th",
	"connerAdHide": "connerAdHide-1rxnplnl connerAd--IEjC_th",
	"connerClose": "connerClose-23R5f3iu"
};
module.exports = exports;
